import { ModBanner } from '@moderneinc/design-system-components';
import type { FunctionComponent } from 'react';
import { PROFILING_DOCS_URL } from '../../constants/general';
import { useCapabilities } from '../../hooks/use-capabilities.hooks';
import { ProfilingIndicatorDot } from './profiling-indicator-dot.component';

export const ProfilingBanner: FunctionComponent = () => {
  const { profiling } = useCapabilities();

  const handleLinkClick = () => {
    window.open(PROFILING_DOCS_URL, '_blank', 'noopener,noreferrer');
  };

  if (!profiling.isActive || !profiling.session) {
    return null;
  }

  const { user } = profiling.session;
  const userName = user.username || user.email;
  const message = `${userName} has enabled system profiling. Requests may be slower than usual until it's turned off.`;

  return (
    <ModBanner
      intent="info"
      type="outlined"
      message={message}
      messagePosition="left"
      icon={<ProfilingIndicatorDot />}
      linkText="Go to docs"
      onLinkClick={handleLinkClick}
    />
  );
};
